<template>
  <div>
    <!-- :class="{ 'tasks-box__active': activeMode, 'tasks-box': !banPutting }" -->
    <draggable
      v-model="tasks"
      handle=".task-handle"
      ghost-class="ghost-task"
      drag-class="task-drag"
      :disabled="isMobile"
      :sort="true"
      :group="group || 'tasks'"
      @start="$emit('dragging', true)"
      @end="$emit('dragging', false)"
      @change="inputChanged"
    >
    <!-- <transition-group name="fade"> -->
        <template v-for="task in tasks">
            <Task
              :key="task.id"
              :task="task"
              class="mb-2 task-handle"
              :forceOpen="forceOpen"
              :taskBoxName="taskBoxName"
              @doubleClick="$emit('taskDoubleClick', task)"
              @edit="$emit('edit', task)"
            />
          </template>
   <!-- </transition-group> -->

    </draggable>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Task from './Task'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  components: {
    draggable,
    Task,
  },
  props: [
    'value',
    'activeMode',
    'group',
    'banPutting',
    'forceOpen',
    'moveToChange',
    'taskBoxName'
  ],
  data () {
    return {
      dragging: false,
      tasks: [],
      // defaultClass: '// 'tasks'
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler (value) {
        this.tasks = value
      }
    },
  },
  computed: {
    isMobile () {
      return this.$store.getters.isMobile
    },
  },
  methods: {
    getListIndex (newIndex) {
      const taskBefore = this.tasks[newIndex - 1]
      const taskAfter = this.tasks[newIndex + 1]

      console.log('taskBefore', taskBefore)
      console.log('taskAfter', taskAfter)

      if (!taskBefore && !taskAfter) {
        return 1000
      } else if (!taskBefore) {
        return (_.isNumber(taskAfter.listIndex) ? taskAfter.listIndex : taskAfter.createdAt.seconds) + 1
      } else if (!taskAfter) {
        return (_.isNumber(taskBefore.listIndex) ? taskBefore.listIndex : taskBefore.createdAt.seconds) - 1
      } else {
        const indexBefore = taskBefore.listIndex || taskBefore.createdAt.seconds
        const indexAfter = taskAfter.listIndex || taskAfter.createdAt.seconds

        return (indexBefore + indexAfter) / 2.0
      }
    },
    inputChanged (event) {
      console.log(event)

      if (event.added && this.moveToChange) {
        const listIndex = this.getListIndex(event.added.newIndex)

        trackAnalytics(this, 'app_action', 'task', 'task_update_box', this.$store.getters.daysFromRegistration)
        this.$store.dispatch('UPDATE_TASK', { task: event.added.element, updateFields: { ...this.moveToChange, listIndex } })
      } else if (event.moved) {
        const listIndex = this.getListIndex(event.moved.newIndex)

        console.log('new listIndex', listIndex)

        this.$store.dispatch('UPDATE_TASK', { task: event.moved.element, updateFields: { listIndex } })
      }

      this.$emit('input', this.tasks)
    }
  }
}

</script>
